import {createFileRoute} from '@tanstack/react-router';

import {ProjectDetailPage} from '@/modules/projects/pages/ProjectDetailPage';

/**
 * URL state for the project detail. `from` records where the user opened the
 * project from, so the back link returns to that client (when opened from a
 * client) or to Projects (the default). Optional so bare links still work.
 */
export interface ProjectDetailSearch {
  from?: 'client';
}

const validateProjectDetailSearch = (search: Record<string, unknown>): ProjectDetailSearch => ({
  from: search.from === 'client' ? 'client' : undefined,
});

export const Route = createFileRoute('/_authenticated/projects/$projectId')({
  validateSearch: validateProjectDetailSearch,
  component: ProjectDetailPage,
});
